const DeliveryPreferred = {
  on: '1',
  off: '0'
};

export default DeliveryPreferred;



// WEBPACK FOOTER //
// ./src/constants/delivery-preferred.js